import Typography from '@mui/material/Typography'
import React from 'react'

const Products = ({products}) => {
    return (
        <>
            <Typography variant="h3" component="h3" color="primary">Products</Typography>
            <ul>
                {products?.map((product, idx) => (
                    <li key={idx}>
                        <span>{product.Quantity} x {product.ProductTitle}</span>
                    </li>
                ))}
            </ul>
        </>
    )
}

export default Products